import React, { useCallback, useEffect } from 'react';
import ClientDetail from '../Editors/ClientDetail';
import ClientDepartmentList from '../EntityList/ClientDepartmentList';
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tabs'
import { Switch, useHistory, useParams, Route } from 'react-router-dom';
import { ClientMessageLog, ViewMessageLogModal } from '../EntityList/ViewMessageLog';
import { useFormikContext } from 'formik';
import { useEdit } from '../../Services/EditContext';
import CharterRequest from '../EntityList/CharterRequestsSupplier'
import { useAuth } from '../../Services/AuthContext';
import MarginDetails from '../Editors/MarginDetails';

import ClientModal from '../Models/ClientModal';
import TimeLine from '../EntityList/TimeLine';


const ClientEditor = ({ route,isNewItem ,entity}) => {
    const { values } = useFormikContext();
    const { id } = values;
    const params = useParams();
    const { clientAction } = params;
    const [ auth ] = useAuth(); 
    const [edit] = useEdit();
    const { push } = useHistory();
     const setActiveKey = useCallback((tab) => {
        if (route && id && tab && !edit) {
            push(route + '/' + id + '/' + tab);
        }
    }, [push, route, id, edit]);
    useEffect(() => {
        if (edit) {
            setActiveKey('Detail')
        }
    }, [edit,setActiveKey]);
    useEffect(() => {
        const allowed = ['Detail', 'Departments', 'Charters','Margin', 'Messages'];
        const f = allowed.find(x => x === clientAction)
        if (route && !f && !edit && !clientAction && id) {
            push(route + '/' + id + '/Detail');
        }
    }, [clientAction, id, route,push,edit])
    return <Tabs activeKey={clientAction} onSelect={setActiveKey}>
        <Tab key={'Detail'} eventKey={'Detail'} title='Detail' >
            <ClientDetail invite={isNewItem} />
        </Tab>
        {!edit && <Tab key={'Departments'} eventKey={'Departments'} title='Departments' style={{ height: '400px' }} >
            {clientAction === "Departments" && <ClientDepartmentList route={route + '/' + id + '/' + clientAction} item={values} parentHeight={400} />}
        </Tab>}
        {!edit && <Tab key={'Charters'} eventKey={'Charters'} title='Charters' style={{ height: '600px' }} >
            {clientAction === 'Charters' ? <CharterRequest area='client' route={route + '/' + id + '/' + clientAction} item={values} parentHeight={550} /> : null}
        </Tab>}
        {auth && auth.role === 'Admin' && !edit && <Tab key={'Margin'} eventKey={'Margin'} title='Margin' style={{ height: '400px' }} >
            {clientAction === 'Margin' ? <MarginDetails id={id} route={route + '/' + id + '/' + clientAction} item={values} parentHeight={400} /> : null}
        </Tab>}
        {!edit && <Tab key={'Messages'} eventKey={'Messages'} title='Messages' style={{ height: '400px' }} >
            {clientAction === "Messages" && <ClientMessageLog itemParam='clientId' route={route + '/' + id + '/' + clientAction} item={values} clientId={id} parentHeight={400} />}
        </Tab>
        }
        {!edit && <Tab key={'Timeline'} eventKey={'Timeline'} title='Timeline' style={{ height: '400px' }} >
            {clientAction === 'Timeline' ? <TimeLine clientCol charterRequestCol supplierCol  type={"Client"} item={values} route={route + '/' + id + "/Timeline"} parentHeight={400} headerHeight={0} /> : null}
        </Tab>
        }
        <Switch>


            <Route path={route + '/' + id + '/Messages/:messageId'} render={() => <ViewMessageLogModal />} />
            <Route path={route + '/' + id + '/Charters/:list/:activeKey/:charterRequestId'} render={() => <ClientModal route={route} entity={entity} itemParam='charterRequestId' > <CharterRequest entity={entity} route={route} /></ClientModal>} />
            <Route path={route + '/' + id + '/Charters/:list/:activeKey'} render={() => <ClientModal route={route} entity={entity} itemParam='charterRequestId' > <CharterRequest entity={entity} route={route} /></ClientModal>} />
            <Route path={route + '/' + id + '/Charters/:list'} render={() => <ClientModal route={route} entity={entity} itemParam='charterRequestId' > <CharterRequest entity={entity} route={route} /></ClientModal>} />


        </Switch>
    </Tabs >
}
export default ClientEditor;